export default __webpack_public_path__ + "static/media/031-key.cf68addb.png";